import { render, staticRenderFns } from "./ModifyWork.vue?vue&type=template&id=2ac61482"
import script from "./ModifyWork.vue?vue&type=script&lang=js"
export * from "./ModifyWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports